import { useEffect } from "react";

import { OrderFields } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useOrderFormik from "../useOrderFormik";

// After loading offers, need to update prices stored in formik

const useUpdatePrices = (): void => {
  const {
    values: { [OrderFields.DELIVERY_METHOD]: deliveryMethod },
    setFieldValue,
  } = useOrderFormik();

  const {
    dynamicData: { offers },
  } = useOrderData();

  useEffect(() => {
    const selectedOffer = offers.find(
      ({ deliveryMethod: offerDeliveryMethod }) => offerDeliveryMethod === deliveryMethod
    );
    setFieldValue(OrderFields.PRICE, selectedOffer?.price ?? undefined);
    setFieldValue(
      OrderFields.ORIGINAL_PRICE,
      selectedOffer?.originalPrice && selectedOffer?.originalPrice !== selectedOffer?.price
        ? selectedOffer?.originalPrice
        : undefined
    );
  }, [deliveryMethod, offers, setFieldValue]);
};
export default useUpdatePrices;
